module.exports = __webpack_public_path__ + "img/chess_japanchess03.80e6fb52.png";